import {ReactComponent as SiteLogo} from '../img/bast_logo.svg';
import {useContext, useState} from "react";
import SiteContext from "../context/SiteContext";
function SiteMenu () {

    const {menuOpen, setMenuOpen} = useContext(SiteContext);

    return (
        <nav className="site-menu">
            <SiteLogo className="site-menu-logo"/>
            <div className={`site-menu-list-wrapper ${menuOpen ?'open':''}`}>
                <button className="site-menu-list-toggle" onClick={() => setMenuOpen(!menuOpen)}>
                    <span className="site-menu-list-toggle-icon">
                    </span>
                </button>
                <ul className="site-menu-list" onPointerDown={(e) => e.stopPropagation()}>
                    <a href="https://bast.ai" className="site-menu-list-item">
                        <span className="site-menu-list-item-label">Home</span>
                    </a>
                    <a href="https://bast.ai#about" className="site-menu-list-item">
                        <span className="site-menu-list-item-label">About</span>
                    </a>
                    <a href="https://bast.ai#demo" className="site-menu-list-item">
                        <span className="site-menu-list-item-label">Contact</span>
                    </a>
                    <span className="site-menu-list-item selected">
                    <span className="site-menu-list-item-label">Demo</span>
                </span>
                </ul>
            </div>

        </nav>
        )
}

export default SiteMenu;
